import React, { useState, useEffect, useRef, useReducer } from 'react';
import { getsystemlis } from '../../utils/api'
import { useTranslation } from 'react-i18next'
import { List, DateSelect, Button } from 'zarm';

const Country: React.FC = () => {

  const { t } = useTranslation()



  const country = [ 'China', 'United States', 'France', 'Britain', 'Germany', 'India']
  const [city, setcity] = useState([]) as any

  const setRegion = async () => {
    await getsystemlis('sys_location_selection').then((res) => {
      setcity(res.data)

    })
  }

  const setcountry = (item: string) => {
    localStorage.setItem('country', item)
    window.history.back()

  }

  const [show, setshow] = useState(false)

  useEffect(() => {

    window.scrollTo(0, 0);
    setRegion()
  }, []);


  return <div style={{ color: '#fff', textAlign: 'center', padding: '20px' }}>
    <div style={{ padding: '20px', fontSize: '24px', fontWeight: '700',cursor: 'pointer' }} onClick={()=>setshow(!show)}>
      {t('Pleaseselectyourcountry')}（Delete after testing）
    </div>
    <div style={{ fontSize: '14px', marginTop: '10px' }}>{
      city.map((item: any, index: number) =>
        <div key={index} onClick={() => setcountry(item.dictLabel)} style={{ padding: '15px', borderBottom: '1px solid #464646',cursor: 'pointer' }}>{item.dictLabel}</div>)
    }</div>
    {show&&
      <div style={{ color: '#000'}}>
       <div style={{ color: '#fff',padding:'20px'}}>Test time selection（Delete after testing）</div> 
        <Demo></Demo>
      </div>
    }


  </div>

};



const Demo = () => {
  const [value, setValue] = useState(new Date() as any);

  return (
    <List>
      <List.Item
        title="日期选择"
        suffix={
          <Button
            size="xs"
            onClick={() => {
              setValue(undefined);
            }}
          >
          
          </Button>
        }
      >
        <DateSelect
          value={value}
          onChange={(value, items) => {
            console.log('DateSelect onChange', value, items);
          }}
          onConfirm={(value, items) => {
            setValue(value);
            console.log('DateSelect onConfirm', value, items);
          }}
          filter={(type, { value }) => {
            if (type === 'day') return value % 5 === 0;
            return true;
          }}
        />
      </List.Item>
    </List>
  );
};



export default Country;